import { uniqueId } from "lodash-es";
import { create } from "zustand";

import { DownloadPanelEntry } from "@/components/common/DownloadPanel";
import { zustandHmrFix } from "@/utils/zustand-hmr";

interface DownloadStore {
  downloads: Record<string, DownloadPanelEntry>;
  isVisible: boolean;
  isExpanded: boolean;

  addDownload: (fileName: string) => string;
  updateDownloadStatus: (id: string, status: DownloadPanelEntry["status"], errorMessage?: string) => void;
  clearDownloads: () => void;
  setVisible: (visible: boolean) => void;
  setExpanded: (expanded: boolean) => void;
  toggleExpanded: () => void;
}

export const useDownloadStore = create<DownloadStore>((set) => ({
  downloads: {},
  isVisible: false,
  isExpanded: false,
  addDownload: (fileName: string) => {
    const downloadId = uniqueId("download-");

    set((state) => ({
      downloads: { ...state.downloads, [downloadId]: { id: downloadId, fileName, status: "downloading" } },
      isVisible: true,
    }));

    return downloadId;
  },
  updateDownloadStatus: (id: string, status: DownloadPanelEntry["status"], errorMessage?: string) => {
    set((state) => ({
      downloads: { ...state.downloads, [id]: { ...state.downloads[id], status, errorMessage } },
    }));
  },
  clearDownloads: () => set({ downloads: {} }),
  setVisible: (isVisible: boolean) => set({ isVisible }),
  setExpanded: (isExpanded: boolean) => set({ isExpanded }),
  toggleExpanded: () => set((state) => ({ isExpanded: !state.isExpanded })),
}));

zustandHmrFix("download-store", useDownloadStore);
